import {Injectable} from '@angular/core';
import {NgbDateAdapter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

/**
 * Example of a Native Date adapter
 */
@Injectable()
export class NgbDateStringAdapter extends NgbDateAdapter<string> {

    fromModel(dateString: string): NgbDateStruct {
        if (!dateString) {
            return null;
        }
        const date = new Date(dateString);
        return (date && date.getFullYear) ? {year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()} : null;
    }

    toModel(date: NgbDateStruct): string {
        if (!date) {
            return null;
        }
        const month = date.month < 10 ? '0' + date.month : date.month;
        const day = date.day < 10 ? '0' + date.day : date.day;
        return `${date.year}-${month}-${day}`;
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/services/ngb-date-string-adapter.service.ts